import { RichTextStyles } from '@cinch-labs/design-system'
import { renderWithResolver } from '@cinch-nx/landing-ui-shared'
import Image from 'next/legacy/image'

import styles from './jargon-content.module.css'
import { JargonBody } from './types/jargon-content'

export const JargonContent: React.FC<JargonBody> = ({
  question,
  answer,
  image,
}: JargonBody) => (
  <article className={styles.article} data-testid="jargon-article">
    <div className={styles.content}>
      <h2 className={styles.question}>{question}</h2>
      <RichTextStyles>{renderWithResolver(answer)} </RichTextStyles>
    </div>
    {image && image.filename && (
      <div className={styles.imageWrapper}>
        <Image
          src={image.filename}
          className={styles.jargonImage}
          layout="responsive"
          width={592}
          height={310}
          objectFit="contain"
        />
      </div>
    )}
  </article>
)
